import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
// import InputLabel from "@material-ui/core/InputLabel";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs } = props;

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create"> Campaigns filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="partnerName"
                  name="partnerName"
                  label="Partner Name"
                  placeholder="Partner Name"
                  className="w-100"
                  value={filterInputs.partnerName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="campaignName"
                  name="campaignName"
                  label="Campaign Name"
                  placeholder="Campaign Name"
                  className="w-100"
                  value={filterInputs.campaignName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="discountPercent"
                  name="discountPercent"
                  label="Discount percent"
                  placeholder="Discount percent"
                  type="number"
                  className="w-100"
                  value={filterInputs.discountPercent}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

            {/* <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <InputLabel htmlFor="expiredDate">Expired date</InputLabel>
                <TextField
                  id="expireDate"
                  name="expireDate"
                  // label="Expire Date"
                  type="datetime-local"
                  className="w-100"
                  value={filterInputs.expireDate}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div> */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
